import React, { useState, useEffect } from 'react';
import Lottie from 'lottie-react';
import { useBrand } from '../../brands/contexts/BrandContext';
import './SplashScreen.scss';

const SplashScreen: React.FC<{ onComplete: () => void }> = ({ onComplete }) => {
  const { brand } = useBrand();
  const [currentAnimation, setCurrentAnimation] = useState<'start' | 'stop' | null>('start');
  const [isVisible, setIsVisible] = useState(true);
  const [opacity, setOpacity] = useState(1);
  const [animationData, setAnimationData] = useState<any>(null);

  // Загружаем анимацию из настроек бренда
  useEffect(() => {
    const animationPath = brand.animations?.splashScreen || 'start.json';

    import(`../../assets/animations/${animationPath}`)
      .then((module) => {
        setAnimationData(module.default);
      })
      .catch((error) => {
        console.error('Failed to load splash screen animation:', error);
        // Fallback на стандартную анимацию
        import('../../assets/animations/start.json').then((module) => {
          setAnimationData(module.default);
        });
      });
  }, [brand]);

  useEffect(() => {
    if (currentAnimation === 'start') {
      // Анимация start длится 2 секунды
      const timer = setTimeout(() => {
        setCurrentAnimation('stop');
      }, 1000);

      return () => clearTimeout(timer);
    } else if (currentAnimation === 'stop') {
      // Анимация stop длится 1 секунду
      const timer = setTimeout(() => {
        // Начинаем плавное исчезновение
        setOpacity(0);
        // После завершения анимации opacity скрываем компонент
        setTimeout(() => {
          setIsVisible(false);
          onComplete();
        }, 500); // Время transition из CSS
      }, 1000);

      return () => clearTimeout(timer);
    }
  }, [currentAnimation, onComplete]);

  if (!isVisible || !animationData) {
    return null;
  }

  return (
    <div className="splash-screen" style={{ opacity }}>
      <div className="splash-screen__animation">
        <Lottie
          animationData={animationData}
          loop={false}
          autoplay={true}
          style={{ width: '100%', height: '100%', maxWidth: '500px', maxHeight: '500px' }}
        />
      </div>
    </div>
  );
};

export default SplashScreen;

